import { api } from '@/api/client';

export interface AssetMeta {
  id: string;
  note_id: string;
  filename: string;
  mime_type: string;
  byte_size: number;
  created_at: string;
  created_by: string;
}

export interface AssetDetail extends AssetMeta {
  ciphertext: string;
  nonce: string;
  dek_wrapped: string;
}

export interface AssetUpload {
  filename: string;
  mime_type: string;
  byte_size: number;
  ciphertext: string;
  nonce: string;
  dek_wraps: Record<string, string>;
}

export interface AssetWrapState {
  asset_id: string;
  /** Wrap-ul userului curent; null dacă nici el nu are unul. */
  dek_wrapped: string | null;
  /** Useri cu share pe notiță care nu pot decripta asset-ul. */
  missing_user_ids: string[];
}

export const assetsApi = {
  list: (noteId: string) => api.get<AssetMeta[]>(`/notes/${noteId}/assets`),
  get: (id: string) => api.get<AssetDetail>(`/assets/${id}`),
  upload: (noteId: string, body: AssetUpload) =>
    api.post<AssetMeta>(`/notes/${noteId}/assets`, body),
  /** Doar asset-urile cu cel puțin un share fără wrap. */
  listWraps: (noteId: string) => api.get<AssetWrapState[]>(`/notes/${noteId}/assets/wraps`),
  addWraps: (noteId: string, wraps: Record<string, Record<string, string>>) =>
    api.post<{ added: number }>(`/notes/${noteId}/assets/wraps`, { wraps }),
  delete: (id: string) => api.delete<null>(`/assets/${id}`),
};
